import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/aprovar-termo/transportadora/empresa/$companyId/$userId")({
  component: RouteComponent
});

function RouteComponent() {
  return <div>Hello "/_private/aprovar-termo/transportadora/empresa/$companyId/$userId"!</div>;
}
